import script from "./SpvOptionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvOptionsModal.vue?vue&type=script&setup=true&lang=js"

import "./SpvOptionsModal.vue?vue&type=style&index=0&id=4c0d30f2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0d30f2"]])

export default __exports__